import { getAuth } from "firebase/auth";
import ENV from "../env";

const getAuthHeader = async () => {
  const user = getAuth().currentUser;
  if (!user) throw new Error("Utilisateur non authentifié");
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
};

export const callAccreditationApi = async (path, payload = {}) => {
  const headers = await getAuthHeader();
  const response = await fetch(`${ENV.firebaseApiUrl}/accreditation${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || data?.message || "Erreur accréditation");
  }
  return data;
};

export const createAccreditation = (payload) => callAccreditationApi("/create", payload);
export const updateAccreditation = (payload) => callAccreditationApi("/update", payload);
export const importAccreditations = (payload) => callAccreditationApi("/import", payload);
export const revokeAccreditationQr = (payload) => callAccreditationApi("/revoke-qr", payload);
export const sendAccreditationEmail = (payload) => callAccreditationApi("/send-email", payload);
